import Card from 'components/Card';
import Text from 'components/Text';
import { View } from 'react-native';
import styled from 'styled-components/native';

export const Content = styled.View`
  padding-top: 24px;
  padding-right: 24px;
  padding-left: 24px;
`;

export const InvoiceDetailCard = styled(Card)`
  padding: 0px;
`;

export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ItemWithMargin = styled(Item)`
  margin-bottom: 16px;
`;

export const ItemText = styled(Text)`
  font-size: 14px;
  font-family: ${props =>
    props.bold ? props.theme.fonts.weight[700] : props.theme.fonts.weight[400]};
`;

export const ItemValueText = styled(Text)`
  font-family: ${props =>
    props.bold ? props.theme.fonts.weight[700] : props.theme.fonts.weight[500]};
`;

export const ItemValueTextLastInvoicePayment = styled(ItemValueText)`
  color: ${props => props.theme.colors.support.slot3};
`;

export const ItemTotal = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px;

  border-top-color: #f2f2f2;
  border-top-width: 1px;
`;

export const ItemTotalText = styled(Text)`
  color: ${props => props.theme.colors.base.slot1};
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 14px;
`;

export const ContentDivider = styled(View)`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.colors.grayscale.slot2};
  margin-bottom: 24px;
  margin-top: 24px;
`;
